<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <div style="width:280px">
        <NeList ref='neList' :neArr='netype' :select='neClick' :typeCode="10006"></NeList>
      </div>
    </template>
    <template v-slot:right_view>
      <ProfileTableMenu @methodEnum='methodEnum'></ProfileTableMenu>
      <ProfileTable ref="profileTable"></ProfileTable>
    </template>
  </BasicLayout>
</template>

<script>
import ProfileTable from '../../../../components/subscriberconfig/epcSubscriber/profile/ProfileTable';
import ProfileTableMenu from '../../../../components/subscriberconfig/epcSubscriber/profile/ProfileTableMenu';
import BasicLayout from '../../../../layouts/BasicLayout';
import NeList from '../../../../components/common/NeList';

export default {
  name: 'ProfileMainPage',
  components: {
    NeList,
    ProfileTable,
    ProfileTableMenu,
    BasicLayout,
  },
  data() {
    return {
      left: {
        show: true,
        name: this.$t("Profile.nelist"),
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: this.$t("Profile.crumb"),
      },
      netype: [4],
    };
  },
  methods: {
    methodEnum(opcode) {
      switch (opcode) {
        case 'add':
          this.$refs.profileTable.openAddProfilePage();
          break;
        case 'mod':
          this.$refs.profileTable.openModProfilePage();
          break;
        case 'del':
          this.$refs.profileTable.delProfiles();
          break;
        case 'qry':
          this.$refs.profileTable.qryProfiles(true);
          break;
        default:
      }
    },
    neClick() {
      this.$refs.profileTable.getGridData(this.$refs.neList.getNe());
    }
  }
};
</script>

<style scoped>

</style>
